export default {
    setUserDocumentsStatistics(state, payload)
    {
        state.documents = payload;
    },
}
